import './style.scss';
import $ from 'jquery';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import {
  joinMatch,
  getMatchDetail,
  getMatchReport,
  createMatch,
} from '../../utils/api/index';
import _t from '../../utils/translate';
import checkMetamask from '../../utils/checkMetamask';
import showAlert from '../../utils/showAlert';
import {getToken, login} from '../../utils/login';
import templateDetail from './template/detail';
import templateReport from './template/report';
import templateInfo from './template/info';
import templateLineups from './template/lineups';
import templateLineupsUpdate from './template/lineups-update';
import templateStats from './template/stats';
import templateHighlights from './template/highlights';

function getLastReport(report) {
  if (report.length) {
    const d = report[0];
    return d;
  }
  return null;
}


const initAudio = () => {
  showAlert({ message: 'You can listen to the match.', icon: 'success' });

  if ($('#myAudio').length === 0) {
    const x = document.createElement('AUDIO');
    x.setAttribute('id', 'myAudio');
    x.setAttribute('controls', 'controls');
    x.classList.add('d-none');

    const z = document.createElement('SOURCE');
    z.setAttribute('src', '');
    z.setAttribute('type', 'audio/mpeg');
    x.appendChild(z);
    const control = JSON.parse(localStorage.getItem('audio-status') || false);
    x.muted = control;
    x.autoplay = true;
    x.volume = 0.3;
    document.body.appendChild(x);
    // const $mute = $(`
    //   <button class="js-my-audio-mute top__right-link" style="width: 30px; height: 30px; border: 0; right: 10px; top: 10px; line-height: 23px;">
    //     <i class="icon-volume-${muted ? 'mute' : 'medium'}" style="position: relative; top: 2px; font-size: 20px;"></i>
    //   </button>
    // `).on('click', (e) => {
    //   if (window.selectedAudio.muted) {
    //     $(e.currentTarget).find('i').addClass('icon-volume-medium').removeClass('icon-volume-mute');
    //     window.selectedAudio.muted = false;
    //     $.cookie('autoplay_audio', 'close');
    //   } else {
    //     $(e.currentTarget).find('i').addClass('icon-volume-mute').removeClass('icon-volume-medium');
    //     window.selectedAudio.muted = true;
    //     $.cookie('autoplay_audio', 'open');
    //   }
    // });

    // $('.js-header-control-bar').append($mute);

    window.selectedAudio = x;
  }
};

const initAudioBG = () => {
  if ($('#myAudio2').length === 0) {
    const x = document.createElement('AUDIO');
    x.setAttribute('id', 'myAudio2');
    x.setAttribute('controls', 'controls');
    x.setAttribute('loop', 'on');
    x.classList.add('d-none');

    const z = document.createElement('SOURCE');
    z.setAttribute('src', '/assets/audio/background.mp3');
    z.setAttribute('type', 'audio/mpeg');
    x.appendChild(z);
    const control = JSON.parse(localStorage.getItem('audio-status') || false);
    x.muted = control;
    x.autoplay = true;
    x.volume = 0.05;
    document.body.appendChild(x);
    window.selectedAudioBG = x;
  }
};


const matches = async () => {
  const element = $('.widget_Tourney_MatchDetail, .widget_Tourney_Matches');
  if (!element.length) {
    return;
  }

  if ($('.js-match-detail').length) {
    initAudio();
    initAudioBG();
    let timer;

    let homeData = null;
    let guestData = null;
    let matchData = null;
    const getMatchDetailHtml = async () => {

      if (!guestData) {
        const { guestTeamData, homeTeamData, data } = await getMatchDetail({
          data: {
            matchId: $('.js-match-detail').data('id'),
          },
        });
        $('.js-match-lineups').html(templateLineups({ guestTeamData, homeTeamData }));

        guestData = guestTeamData;
        homeData = homeTeamData;
        matchData = data;

        return false;
      }

      const { report, stats, highlights, isCompleted } = await getMatchReport({
        data: {
          matchId: $('.js-match-detail').data('id'),
        },
      });

      templateLineupsUpdate({
        isCompleted,
        guestTeamData: guestData,
        homeTeamData: homeData,
        report,
        data: matchData,
        stats,
        highlights,
      });

      const lastReport = getLastReport(report);

      const controlAudio = JSON.parse(localStorage.getItem('audio-status') || true);
      $('.js-match-report').html(templateReport({ report }));
      $('.js-match-info').html(templateInfo({ guestTeamData: guestData, homeTeamData: homeData, stats, highlights, data: matchData }));
      $('.js-match-stats').html(templateStats({ data: matchData, stats, highlights, guestTeamData: guestData, homeTeamData: homeData }));
      $('.js-match-highlights').html(templateHighlights({ data: matchData, stats, highlights }));
      // $('.js-match-detail').html(templateDetail({ data, report, stats, highlights }));
      if (!controlAudio) {
        $('.js-audio-pause').find('i').addClass('icon-volume-high').removeClass('icon-volume-mute2');
      } else {
        $('.js-audio-pause').find('i').addClass('icon-volume-mute2').removeClass('icon-volume-high');
      }

      if (['Goal', 'Penalty_successful', 'Goal_with_assist', 'Free_kick_hit'].includes(lastReport.actiontype)) {
        clearInterval(timer);
        $('.js-message').css('display', 'flex');

        setTimeout(() => {
          $('.js-message').css('display', 'none');
          timer = setInterval(getMatchDetailHtml, 2000);
        }, 6000);
      }

      $('.js-timeline-item.new').addClass('open');
      if ($('.js-timeline-item.new').data('audio')) {
        const control = JSON.parse(localStorage.getItem('audio-status') || false);
        window.selectedAudio.muted = control;
        window.selectedAudio.setAttribute('src', $('.js-timeline-item.new').data('audio'));
        window.selectedAudio.play();
      }
      window.selectedAudioBG.play();

      if (isCompleted) {
        $('.js-audio-pause').hide();
        setTimeout(() => {
          clearInterval(timer);
          window.selectedAudio.pause();
          window.selectedAudioBG.pause();
        }, 1000);
      }
    };
    await getMatchDetailHtml();
    timer = setInterval(getMatchDetailHtml, 2000);
  }

  $(document).on('click', '.js-audio-pause', async (e) => {
    // const control = JSON.parse(localStorage.getItem('audio-status') || true);
    // console.log('audio', control);
    const control = !window.selectedAudio.muted;
    window.selectedAudio.muted = control;
    window.selectedAudioBG.muted = control;
    localStorage.setItem('audio-status', control);

    if (!control) {
      $('.js-audio-pause').find('i').addClass('icon-volume-high').removeClass('icon-volume-mute2');
    } else {
      $('.js-audio-pause').find('i').addClass('icon-volume-mute2').removeClass('icon-volume-high');
    }
  });

  $(document).on('click', '.js-create-match', async () => {

    Swal.fire({
      title: _t('Warning!'),
      html: `<p style="margin-top: 90px" class="text-left">${_t('Do you want to create friendly match.')}</p>`,
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: _t('Sure!'),
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const token = getToken();
        const { message, success, seo } = await createMatch({
          data: {
            token,
          },
        });
        if (success) {
          showAlert({ message, icon: 'success' });
          window.location.href = seo;
        } else {
          showAlert({ message, icon: 'error' });
        }
      }
    });
  });

  $(document).on('click', '.js-join-match', async (e) => {
    const $that = $(e.currentTarget);

    // const sessionKey = window.sessionStorage.getItem('sessionKey');
    const token = getToken();

    if ($that.data('type') === 'Death') {

      if (!await checkMetamask()) {
        return;
      }

      if (!await login()) {
        return;
      }

      const price = $that.data('price');
      const type = $that.data('type');

      Swal.fire({
        title: _t('Death Match Join'),
        html: `<p style="margin-top: 90px" class="text-left">You are joining a match for ${price} $NFSGX</p>`,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: _t('Sure!'),
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
      }).then(async (result) => {
        if (result.isConfirmed) {
          const {message, success} = await joinMatch({
            data: {
              token,
              matchId: $that.data('id'),
            },
          });

          if (success) {
            showAlert({message, icon: 'success'});
            window.location.href = $that.data('seo');
          } else {
            showAlert({message, icon: 'error'});
          }
        }
      });
    } else {
      const { message, success } = await joinMatch({
        data: {
          token,
          matchId: $that.data('id'),
        },
      });

      if (success) {
        showAlert({ message, icon: 'success' });
        window.location.href = $that.data('seo');
      } else {
        showAlert({ message, icon: 'error' });
      }
    }
  });
};

export default matches;
